import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import TransactionDetail from './components/TransactionDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageAdmin',
  components: {
    TransactionDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;